// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Lb8Df","head":"ProcedureTableInfo_head__1AfNT"};